import home from "./home";
import monitor from "./monitor";
import reports from "./reports";
import users from "./users";
import skills from "./skills";
import calls from "./calls";
import plural_ar from "./plural_ar";
import login from "./login";
import profile from "./profile";
import sms from "./sms";
import chat from "./chat";
import kpi from "./kpi";
import forgotPassword from "./forgotPassword";
import campaigns from "./campaigns";
import ivr from "./ivr";
import smartRouting from "./smartRouting";
import settings from "./settings";
const ar = {
  of: "من",
  loading: "جاري التحميل...",
  layouts: {
    Home: "لوحة المعلومات",
    Monitor: "المراقبة",
    Reports: "التقارير",
    Agent_Reports: "التقارير الخاصة",
    Agent_Calls_Report: "سجل المكالمات",
    Agent_Status_Report: "تقرير الحالة",
    Calls_Reports: "المكالمات",
    Performance_By_Period: "الأداء خلال الفترة",
    Total_Performance: "الأداء العام",
    Agent_Performance: "أداء الموظف",
    System_Inbound: "المكالمات الواردة",
    Agent_Leaving_Details: "إستراحة الموظفين بالتفصيل",
    Agent_Leaving_Summary: "إستراحة الموظفين مجملا",
    Agent_Login_Details: "تسجيل الدخول بالتفصيل",
    Agent_Login_Summary: "تسجيل الدخول مجملا",
    Agent_Status_Details: "حالات الموظفين بالتفصيل",
    Agent_Status_Summary: "حالات الموظفين مجملا",
    Agent_KPI_Report: "مؤشرات الأداء الرئيسية",

    Admin: "الإدارة",
    Users_Management: "إدارة المستخدمين",
    "users-management": "إدارة المستخدمين",
    "create-user": "إدارة المستخدمين",
    Skill_Management: "إدارة المجموعات",
    Calls_Management: "إدارة المكالمات",
    profile: "المستخدم",
    "sms-page": "الرسائل النصية",
    logout: "تسجيل الخروج",
    Domains: "الأنظمة",
    Procesors: "المعالجات",
    chat: "التواصل الداخلي",
    "chat-user": "التواصل الداخلي",
    "social-media": "الرسائل",
    Profile: "الملف الشخصي",
    logout_text: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    "ai-assistant": "المساعد الذكي",
    "agent-status-report": "تقرير الحالة",
    "agent-calls-report": "تقرير المكالمات",
    "monitor-board": "لوحة المراقبة",
    "skills-management": "إدارة المجموعات",
    "kpi-management": "إدارة مؤشرات الأداء",
    "call-analysis": "تحليل المكالمة",
    "voice-cdr-details": "تفاصيل المكالمة الصوتية",
    "chat-transcript-details": "تفاصيل المحادثة",
    "campaigns-management": "حملات الاتصال",
    "campaign-new": "حملة جديدة",
    "campaign-edit": "تعديل الحملة",
    "campaign-sounds": "الملفات الصوتية للحملات",
    "campaign-reports": "تقارير الحملة",
    "ivr-management": "منشئ الرد الصوتي",
    "ivr-new": "مسار رد صوتي جديد",
    "ivr-edit": "تعديل مسار الرد الصوتي",
    "ivr-sounds": "الملفات الصوتية للرد الصوتي",
    settings: "الإعدادات",
    "settings-queues": "إدارة المجموعات",
    "settings-queue-config": "إعداد المجموعة",
    "settings-vip": "الأرقام المميزة (VIP)",
    "settings-blacklist": "الأرقام المحظورة",
    "settings-reasons": "أسباب المكالمات",
    "settings-crm": "إعدادات العميل",
    "settings-rating": "تقييم المكالمات",
    "settings-call-settings": "إعدادات المكالمات",
    "settings-kpi": "إدارة مؤشرات الأداء",
    "settings-users": "إدارة المستخدمين",
    "settings-rest-periods": "فترات الراحة",
  },
  general: {
    confirm: "تأكيد",
    cancel: "إلغاء",
  },
  home: home.ar,
  login: login.ar,
  monitor: monitor.ar,
  reports: reports.ar,
  users: users.ar,
  skills: skills.ar,
  calls: calls.ar,
  plural: plural_ar,
  profile: profile.ar,
  sms: sms.ar,
  chat: chat.ar,
  kpi: kpi.ar,
  forgot_password: forgotPassword.ar,
  campaigns: campaigns.ar,
  ivr: ivr.ar,
  smart_routing: smartRouting.ar,
  settings: settings.ar,
};

export default ar;
